import { DefaultRootState } from '@/store/coreReducer.ts'
import { persistableItems } from '@/store/observers/persistableItems.ts'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { type DataRefreshObject, dataRefreshFunctions } from './_dataRefreshItems'

const initiateDataRefresh = createAsyncThunk<any, undefined, { state: DefaultRootState }>(
	'core/initiateDataRefresh',
	(_, thunkAPI) => {
		persistableItems.forEach(item => {
			if (dataRefreshFunctions.has(item)) {
				const refreshObject: DataRefreshObject[] | undefined = dataRefreshFunctions.get(item)
				if (refreshObject !== undefined) {
					refreshObject.forEach(refreshItem => {
						// if (checkRole(refreshItem.roles, user)) {
						refreshItem.thunks.forEach(func => {
							void thunkAPI.dispatch(func())
						})
						// }
					})
				}
			}
		})
	},
)

export { initiateDataRefresh }
